import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { GlobalUploadTray } from "./GlobalUploadTray";

/**
 * Renders the upload tray only for authenticated users on /admin or /hr routes.
 * The UploadProvider stays mounted globally so the engine keeps running across
 * navigation; this component just gates the UI surface.
 */
export function ScopedUploadTray() {
  const location = useLocation();
  const [isAuthed, setIsAuthed] = useState(false);

  useEffect(() => {
    let mounted = true;
    supabase.auth.getSession().then(({ data }) => {
      if (mounted) setIsAuthed(!!data.session?.user);
    });
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsAuthed(!!session?.user);
    });
    return () => {
      mounted = false;
      sub.subscription.unsubscribe();
    };
  }, []);

  const path = location.pathname;
  // Exclude login pages explicitly — auth state can briefly be stale on these routes
  // and the tray must never appear before the user is signed in.
  const inScope =
    (path.startsWith("/admin") && path !== "/admin/login") ||
    (path.startsWith("/hr/") && path !== "/hr/login");
  if (!isAuthed || !inScope) return null;

  return <GlobalUploadTray />;
}
